import TermInfo from "./TermInfo.tsx";
import ProgramBanner from "./ProgramBanner/ProgramBanner.tsx";
import { ExpandedCourse, useCoursesLoaderData } from "./coursesLoader.ts";
import Course from "./Course.tsx";
import { useIntl } from "react-intl";
import PageTitle from "routes/home/common/page-title/PageTitle.tsx";
import PrintReturnBanner from "./PrintReturn/PrintReturnBanner.tsx";
import useSurveyToast from "./useSurveyToast.tsx";
import DefaultTemplate from "routes/home/layout/content-templates/default/DefaultTemplate.tsx";
import VerifyShippingAddressBanner from "./VerifyShippingAddressBanner.tsx";
import styles from "./MyCourses.module.scss";
import CompareAndPurchaseCartButton from "./common/CompareAndPurchaseCartButton.tsx";

export default function MyCourses() {
  const { courses, compareCart } = useCoursesLoaderData();
  const intl = useIntl();
  useSurveyToast();
  const title = intl.formatMessage({ defaultMessage: "My Courses" });
  return (
    <DefaultTemplate
      title={title}
      headerConfig={{
        bonusButtons: <CompareAndPurchaseCartButton cart={compareCart} />,
      }}
    >
      <PageTitle title={title} noHeading />
      <div>
        <ProgramBanner />
        <TermInfo />
        <div className={styles.bannersContainer}>
          <PrintReturnBanner />
          <VerifyShippingAddressBanner />
        </div>
        {courses.length &&
          courses.map((course: ExpandedCourse) => (
            <Course key={course.id} {...course} />
          ))}
      </div>
    </DefaultTemplate>
  );
}
